<template>
<div>
  <vs-table :data="data" maxHeight="60vh">
    <template slot="thead">
      <vs-th> {{ $t('id').toUpperCase() +' '+ $tc('container') | capitalize }} </vs-th>
      <vs-th> {{ $t('label') | capitalize }} </vs-th>
      <vs-th> {{ $tc('type') | capitalize }} </vs-th>
      <vs-th> {{ $t('quantity') | capitalize }} </vs-th>
      <vs-th> {{ $t('located_at') | capitalize }} </vs-th>
      <vs-th> {{ $t('comments') | capitalize }} </vs-th>
    </template>
    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ data[i].id }}
        </vs-td>
        <vs-td>
          {{ data[i].label }}
        </vs-td>
        <vs-td>
          {{ data[i].type_name }}
        </vs-td>
        <vs-td>
          {{ data[i].quantity }}
        </vs-td>
        <vs-td>
          {{ data[i].location_name }}
        </vs-td>
        <vs-td>
          {{ data[i].comment }}
        </vs-td>
     
      </vs-tr>
    </template>
  </vs-table>
</div>
  
  
</template>

<script>
import dashboard from '@/http/requests/dashboard'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    entryId: {
      type: String,
      required:true
    }
  },
  components:{
    dashboard
  },
  data(){
    return {
      container:{},
      containerTypes:[]
    }
  },
  methods: {
    init(){
      this.getContainerTypes()
    },
    getContainerTypes(){
      dashboard.getContainerTypes().then(res => {
        this.containerTypes=res.data.data
      }).catch( err => {
        console.log(err)
      })
    },
    updateContainer(data) {
      this.container = data
      this.$store.dispatch('toggleSidebar', 'entry-container')
    },
    containerUpdated(){
      this.$emit('containerUpdated')
    }
  },
  mounted() {
    this.init()
  },
}
</script>

<style>
</style>